import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const updateHolidaySlotGroup = (id, changes) => {
	return fetch(apiBasename + '/holidaySlotGroup/' + id, authorization({
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(changes)
	}))
	.then(checkStatus)
	.then((res) => res.json());
};

export const removeHolidaySlotGroup = (id) => {
	return fetch(apiBasename + '/holidaySlotGroup/' + id, authorization({
		method: 'DELETE'
	}))
	.then(checkStatus);
};
